import { ChevronDown } from 'lucide-react'
import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'

export function ReviewDisclosure({
  title,
  count,
  children,
}: {
  title: string
  count?: number
  children: ReactNode
}) {
  return (
    <Collapsible className="min-w-0 border-b border-border last:border-b-0">
      <CollapsibleTrigger asChild>
        <Button
          variant="ghost"
          className="group h-auto w-full justify-between gap-3 rounded-none px-0 py-4 text-left hover:bg-transparent"
        >
          <span className="min-w-0 whitespace-normal font-medium">{title}</span>
          <span className="flex shrink-0 items-center gap-3 text-muted-foreground">
            {count !== undefined && <span className="text-xs tabular-nums">{count}</span>}
            <ChevronDown className="size-4 transition-transform group-data-[state=open]:rotate-180" />
          </span>
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent className="pb-4">{children}</CollapsibleContent>
    </Collapsible>
  )
}
